import { isPlatformBrowser } from '@angular/common'
import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  HostListener,
  Inject,
  PLATFORM_ID,
  OnDestroy,
  ChangeDetectorRef,
} from '@angular/core'
import { UntypedFormGroup, Validators, FormControl, ValidatorFn, AbstractControl } from '@angular/forms'
import * as _ from 'lodash'
import moment from 'moment'
//import { GooglePlaceDirective } from 'ngx-google-places-autocomplete'
//import { Address } from 'ngx-google-places-autocomplete/objects/address'
import { NGXLogger } from 'ngx-logger'
import {
  dateDashesSetInstead,
  mobileHyphensComplete,
  mobileHyphensSetInstead,
  ssnHyphensComplete,
} from 'src/app/core/helpers/app-link'
import { checkIsInputArea, transformLoanAmountWithCommas } from 'src/app/core/helpers/fields-utils'
import { numberWithCommas } from 'src/app/core/helpers/inputs-helper'
import { getLoanInfoCleanTemp } from 'src/app/core/helpers/loanInfoUtils'
import { ModalTypes } from 'src/app/core/helpers/modal-store'
import { ApiService } from 'src/app/core/services/api.service'
import { ModalStateService } from 'src/app/core/services/modal-state.service'
import { PageNavigationService } from 'src/app/core/services/page-navigation.service'
import { PageService } from 'src/app/core/services/page.service'
import { UserStateService, UserStateType } from 'src/app/core/services/user-state.service'
import { environment } from 'src/environments/environment'
import { LoanInfo } from '../../../../core/helpers/interfaces'
import { ModalPopupsService } from '../modal-popups.service'
import { SESSION_TIMER_MINUTES } from '../options-utils/modal-shared'
import { formControlsId, formControlsInputId, substatuses } from './form-utils/const-lists'
import { getScrollBotToLinks, setScrollBotToLinks } from './form-utils/form-scroll'
import { checkAndRestoreForm, setStateAs } from './form-utils/form-state'
import { parseAddress } from './form-utils/form-utils'
import {
  setDateAfterChangeAllDashes,
  // setEventKeyPressAmount,
  setEventKeysDesktopShiftTab,
  setEventKeysDesktopTabReturn,
  setEventKeysMobileReturn,
  setFormMobileAfterChangeAllHyphens,
  setSSNAfterChangeAllHyphens,
  setTermsOfUseReturnTab,
  setUpperFirstLettersSubscribes,
  showAllInvalid,
} from './form-utils/formevents'
import { makeFormGroup } from './form-utils/formgroup'
import {
  changeInputVisibleStateAll,
  inputSelectAriaCheckActiveState,
  inputAriaCheckActiveStateSSN,
} from './form-utils/inputs'

import { RuntimeConfigService } from 'src/app/runtime-config.service'
@Component({
    selector: 'app-modal-options-form',
    templateUrl: './modal-options-form.component.html',
    styleUrls: ['./modal-options-form.component.scss'],
    standalone: false
})
export class ModalOptionsFormComponent implements OnInit, OnDestroy {
  @Output() showPopup: EventEmitter<any> = new EventEmitter()
  @Output() dataSubmited: EventEmitter<any> = new EventEmitter()
  @Output() runSessionTimer: EventEmitter<any> = new EventEmitter()
  @Output() toggleLoader: EventEmitter<any> = new EventEmitter()
  @Output() showErrorPopupType: EventEmitter<string> = new EventEmitter()
  @Input() FULL_DEV: any = false
  @Input() isBlocked: any = false
  @Input() insideCoapp: any = false
  @Input() hooverPopupText = ''
  @Input() loanAcctId: any = null
  @Input() layout: any = null
  @Input() breakpoints: any = {
    extraSmall: false,
    small: false,
    medium: false,
    large: true,
    extraLarge: true,
  }
  @Input() set loanAmount(value: number) {
    if (value === null) {
      return
    }
    this.loanInfo.amount = '$' + this.transformLoanAmountWithCommas(value)
  }
  @Input() clientAddress: any = {
    address1: '162 PO BOX 162',
    address2: '',
    city: 'MOOSE PASS',
    state: 'Alaska',
    zipCode: 99631,
  }
  private _savedUserAddress: any = {
    address1: '',
    address2: '',
    city: '',
    state: '',
    zipCode: '',
  }
  @Input() set useClientAddress(value: boolean) {
    const current = this.pageNavigationService.getCurrentState()
    if (value === true) {
      this._savedUserAddress = this.loanInfo.address
      this.loanInfo.address = this.clientAddress
      this.logger.info(this.clientAddress)
      if (this.clientAddress.state) {
        setStateAs(this, document, this.clientAddress.state)
      }
      // this.loanInfo.address.state = this.clientAddress.state
    }
    // not need to restore if popstate
    else if (current?.trigger !== 'popstate') {
      this.loanInfo.address = this._savedUserAddress
    }
  }

  transformLoanAmountWithCommas = transformLoanAmountWithCommas

  // extesion for full_dev
  hideFullDev = false
  // result of injected Transunion script
  tuSessionId
  // injected Transunion script
  TrustevV2
  // session-timeout
  rmTimeout = null
  // blocker for submit button
  submitClicked = false

  ssn_dobErrors = false
  showMinAmountError = false
  showMaxAmountError = false
  showHawaiiError = false

 // @ViewChild('places') places: GooglePlaceDirective
  placesOptions = {
    // types: [
    //   'street_number',
    //   'route',
    //   'locality',
    //   'administrative_area_level_1',
    //   'administrative_area_level_3',
    //   'administrative_area_level_2',
    // ],
    componentRestrictions: { country: 'us' },
  }

  loanForm: UntypedFormGroup
  loanInfo: LoanInfo = getLoanInfoCleanTemp()
  states: any[] = null

  showHooverMenu = false

  // const lists
  substatuses = substatuses
  formControlsId = formControlsId
  formControlsInputId = formControlsInputId

  public events = {
    /**
     * on enter in form if not input submit form
     * {@link ModalOptionsFormComponent.enterSubmitonKeydownListener }
     */
    isEnterSubmit: true,

    /**
     * mobile enter event
     * {@link setEventKeysMobileReturn }
     */
    isMobileEnterNext: true,

    /**
     * enter / tab desktop move
     * {@link setEventKeysDesktopTabReturn }
     */
    isDesktopEnterOrTabPress: true,

    /**
     * shift + tab desktop reverse move
     * {@link setEventKeysDesktopShiftTab }
     */
    isDesktopShiftTabPress: true,

    /**
     * shift + tab from terms of use
     * {@link setTermsOfUseReturnTab }
     */
    isDesktopShiftTabTermsPress: true,

    // /**
    //  * set , and . preventor to amount input
    //  * {@link setEventKeyPressAmount }
    //  */
    // isCommaPointAmountPreventor: true,

    /**
     * set valueChanges events on make first letters capital
     * {@link setUpperFirstLettersSubscribes }
     */
    isValueChangesCapitalize: true,

    /**
     * on focusout set hyphens on mobile input
     * {@link setFormMobileAfterChangeAllHyphens }
     */
    isFocusOutMobileSetHyphens: true,

    /**
     * on focusout set hyphens on ssn
     * {@link setSSNAfterChangeAllHyphens }
     */
    isFocusOutSSNSetHyphens: true,

    /**
     * on focusout set dashes on date input
     * {@link setDateAfterChangeAllDashes }
     */
    isFocusOutDateSetDashes: true,

    /**
     * on valueChanges add active input area to inputs in list
     * {@link showAllInvalid }
     */
    isValueChangesSetActiveArea: true,

    /**
     * clickout
     * check current clicked element
     * if element parent had active/inactive
     * than go through (almost) all OTHER form inputs and reset them active/inactive
     * else go throght (almost) all form inputs and reset them active/inactive
     * {@link ModalOptionsFormComponent.clickout }
     */
    isClickoutResetActiveInactiveInputs: true,
  }

  constructor(
    public modalPopups: ModalPopupsService,
    public page: PageService,
    private api: ApiService,
    public userStateService: UserStateService,
    public pageNavigationService: PageNavigationService,
    public modalStateService: ModalStateService,
    public logger: NGXLogger,
    private cdr: ChangeDetectorRef,
    private runtimeConfigService: RuntimeConfigService,
    @Inject(PLATFORM_ID) private platformId: object
  ) {
    this.loadStates()
    this.enterSubmitonKeydownListener()
    checkAndRestoreForm(this, document)
  }

  /**
   * 1. create form group
   * 2. enable onChanges events
   * 3. check popstate for scroll to links
   * 4. setup timer
   */
  ngOnInit(): void {
    if(this.modalPopups.checkLoanOptionsEnteredData){
      this.loanInfo = this.modalPopups.checkLoanOptionsEnteredData
    }
    // client code
    if (isPlatformBrowser(this.platformId)) {
      this.loanForm = makeFormGroup(this)
      this.onChanges()
      getScrollBotToLinks(this, document)
      // If we in coapp or decline coapp need to wait
      if (!this.insideCoapp) {
        this.setRunTimerByTimeout(SESSION_TIMER_MINUTES)
      }
    }
  }

  /**
   * 1. remove invalid state
   * 2. clear timer
   */
  ngOnDestroy(): void {
    // console.log('on destroy!')
    // remove invalid state
    this.userStateService.isInvalidState = false
    if (this.rmTimeout) {
      clearTimeout(this.rmTimeout)
    }
  }

  /**
   * on keydown event 'Enter' if not input is active press submit button
   */
  private enterSubmitonKeydownListener(): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    if (!this.events.isEnterSubmit) {
      return
    }
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Enter') {
        const formObj = document.getElementById('formId')
        if (!formObj) {
          return
        }
        if (document.activeElement.tagName === 'INPUT') {
          event.preventDefault()
          return
        }
        const inpt = document.getElementById('submitBtn')
        inpt.click()
        return
      }
    })
  }

  /**
   * goes through all address fields and set them invalid
   */
  private setInvalidFullAddress() {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    const formAddressArr = ['address', 'city', 'state', 'zipCode']
    // at first set invalid to controls
    formAddressArr.forEach((x) => {
      this.loanForm.controls[x].setErrors({ incorrect: true })
      this.loanForm.controls[x].markAsTouched()
    })
    // second active clickout event and others by clicking on form top
    const formDiv = document.getElementById('formId')
    if (formDiv) {
      formDiv.click()
    }
    // remove freezed inactive from state
    const stateDiv = document.getElementById('stateDiv')
    if (stateDiv && stateDiv.classList.contains('input-area__inactive')) {
      stateDiv.classList.remove('input-area__inactive')
    }

    this.cdr.detectChanges()
  }

  /**
   * goes through all provided fields and set them invalid
   * @param formAddressArr - arr of controls
   */
  private setInvalidSimple(formAddressArr) {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    // at first set invalid to controls
    formAddressArr.forEach((x) => {
      this.loanForm.controls[x].setErrors({ incorrect: true })
      this.loanForm.controls[x].markAsTouched()
    })
    // second active clickout event and others by clicking on form top
    const formDiv = document.getElementById('formId')
    if (formDiv) {
      formDiv.click()
    }
    this.cdr.detectChanges()
  }

  /**
   * @todo
   * clear state dropdown
   * - not tested
   */
  private setStateClear(): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    const stateOptionLarge = document.getElementById('stateOptionLarge') as any
    if (stateOptionLarge) {
      stateOptionLarge.selectedIndex = 0
      return
    }
    const stateOptionSmall = document.getElementById('stateOptionSmall') as any
    if (stateOptionSmall) {
      stateOptionSmall.selectedIndex = 0
      return
    }
  }

  /**
   * set '' to form control fields
   * @param formAddressArr - arr of controls
   */
  private clearFields(formAddressArr): void {
    formAddressArr.forEach((x) => {
      this.loanForm.controls[x].setValue('')
    })
  }

  /**
   * on invalid state set full address as invalid
   */
  public setInvalidAddressCauseState() {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    this.setInvalidFullAddress()
    this.toggleLoader.emit(false)
    this.cdr.detectChanges()
    const formDiv = document.getElementById('formId')
    if (formDiv) {
      formDiv.click()
    }
  }

  private setPlaceholder(inputId: string, text: string): void {
      if (isPlatformBrowser(this.platformId)) {
    const inpt = document.getElementById(inputId)
    if (inpt) {
      inpt?.setAttribute('placeholder', text)
    }
  }
  }

  private setActiveToInputById(inputId) {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    const inpt = document.getElementById(inputId)
    if (inpt) {
      inputSelectAriaCheckActiveState(inpt.parentElement, true)
    }
  }

  /**
   * on 400 errors place error fields and clear them if needed;
   */
  public setInvalidPartsCauseAPIErrors(): void {
    const ssnInputId = 'ssnInputId'
    const ssnPlaceholder = 'xxx-xx-xxxx'
    const dobInputId = 'dobInputId'
    const dobPlaceholder = 'MM/DD/YYYY'

    switch (this.userStateService.type) {
      case UserStateType.address:
        this.setInvalidFullAddress()
        break

      case UserStateType.ssn_dob:
        this.ssn_dobErrors = true
        this.setPlaceholder(ssnInputId, ssnPlaceholder)
        this.setPlaceholder(dobInputId, dobPlaceholder)
        this.clearFields(['socNumber', 'dateOfBirth'])
        this.setInvalidSimple(['socNumber', 'dateOfBirth'])
        setTimeout(() => {
          this.setActiveToInputById(dobInputId)
        }, 200)
        break

      case UserStateType.ssn:
        this.ssn_dobErrors = true
        this.setPlaceholder(ssnInputId, ssnPlaceholder)
        this.setPlaceholder(dobInputId, dobPlaceholder)
        this.setActiveToInputById(dobInputId)
        this.clearFields(['socNumber', 'dateOfBirth'])
        this.setInvalidSimple(['socNumber', 'dateOfBirth'])
        setTimeout(() => {
          this.setActiveToInputById(dobInputId)
        }, 200)
        break

      case UserStateType.dob:
        this.ssn_dobErrors = true
        this.setPlaceholder(dobInputId, dobPlaceholder)
        this.setActiveToInputById(dobInputId)
        this.clearFields(['dateOfBirth'])
        this.setInvalidSimple(['dateOfBirth'])
        setTimeout(() => {
          this.setActiveToInputById(dobInputId)
        }, 200)
        break

      case UserStateType.mobile:
        this.clearFields(['mobile'])
        this.setInvalidSimple(['mobile'])
        break
    }

    this.toggleLoader.emit(false)
    this.cdr.detectChanges()
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    const formDiv = document.getElementById('formId')
    if (formDiv) {
      formDiv.click()
    }
  }

  /**
   * load this.states from API
   */
  private loadStates(): void {
    this.api
      .getStates()
      .toPromise()
      .then((resp) => {
        if (resp?.data) {
          this.states = resp.data
        }
      })
      .catch((error) => {
        this.logger.error(error)
      })
  }

  /**
   * handler for hoover popup
   * @param state - boolean
   * @param e - mouse event
   */
  public onInfoIconTrigger(state: boolean, e: any) {
    if (
      ((e.type === 'mouseenter' || e.type === 'mouseleave') && !this.breakpoints.extraSmall) ||
      e.type === 'click'
    ) {
      this.showHooverMenu = state
    }
  }

  public onClosed(e) {
    this.showHooverMenu = false
  }

  inputItemClick(event: any): void {
    inputSelectAriaCheckActiveState(event.currentTarget)
  }

  inputItemClickSSN(event: any): void {
    inputAriaCheckActiveStateSSN(event.currentTarget)
  }

  // 'street_number',
  // 'route',
  // 'locality',
  // 'administrative_area_level_1',
  // 'administrative_area_level_3',
  // 'administrative_area_level_2',
  // 'postal_code',

  /**
   * Google Places API on change fill fields
   * @param address - Google Places response address
   */
  public autoCompleteOnChange(address: any): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    const parsedAddress = parseAddress(this, address)
    // "17015 Burbank Blvd, Encino, CA 91316, USA"
    const fmt_addresses = address.formatted_address.split(', ')
    this.logger.info(fmt_addresses)

    if (parsedAddress.postal_code) {
      // set zip code
      const zip = document.getElementById('zipCodeInput') as any
      zip.value = parsedAddress.postal_code.long_name
      this.loanInfo.address.zipCode = parsedAddress.postal_code.long_name
      this.loanForm.controls.zipCode.setErrors(null)
    }
    // set address
    if (fmt_addresses.length > 0 && fmt_addresses[0]) {
      const addrInput = document.getElementById('addressInput') as any
      addrInput.focus()
      addrInput.value = fmt_addresses[0]
      this.loanInfo.address.address1 = fmt_addresses[0]
      this.loanForm.controls.address.setErrors(null)
    }
    // set city
    if (fmt_addresses.length > 1 && fmt_addresses[1]) {
      const cityInput = document.getElementById('cityInput') as any
      cityInput.value = fmt_addresses[1]
      this.loanInfo.address.city = fmt_addresses[1]
      this.loanForm.controls.city.setErrors(null)
    }
    // set state
    if (parsedAddress.administrative_area_level_1) {
      setStateAs(this, document, parsedAddress.administrative_area_level_1.short_name)
      this.loanInfo.address.state = parsedAddress.administrative_area_level_1.short_name
      this.loanForm.controls.state.setErrors(null)
      this.loanForm.controls['state'].setValue(parsedAddress.administrative_area_level_1.short_name)
    }

    const items = document.querySelector('.modal-optins').querySelectorAll("[class*='input-area']")
    changeInputVisibleStateAll(this, items)
    this.checkHawaiiPopup(parsedAddress.administrative_area_level_1.short_name)
  }

  async checkHawaiiPopup(val) {
    const stateInfo = await this.modalPopups.isStateAvailable(val)
    if(!stateInfo){
      this.showErrorPopupType.emit('state')
      return
    }
    if (stateInfo.minRequestedAmt) {
      this.modalPopups.changeValue(stateInfo.minRequestedAmt, 'HI')
      if (
        !this.loanInfo.amount ||
        +('' + this.loanInfo.amount).replace(/[$,]/g, '') < stateInfo.minRequestedAmt
      ) {
        if (this.loanInfo.amount) {
          this.showErrorPopupType.emit('hawaii')
          this.showHawaiiError = true
        }
        this.showPopup.emit(true)
      }
    } else {
      if (this.showHawaiiError) {
        // this.showErrorPopupType.emit('none')
        if(+('' + this.loanInfo.amount).replace(/[$,]/g, '') < +this.modalPopups.loanMinValue){
          this.showMinAmountError = true
        }
        this.showHawaiiError = false
        let amVal = this.loanForm.value.amount
        this.loanForm.controls.amount.reset()
        this.loanForm.controls.amount.setValue(amVal)
      }
    }
  }

  /**
   * restart timeout timer if exists
   * @param minutes - timeout minutes
   */
  setRunTimerByTimeout(minutes?): void {
    if (!minutes) {
      minutes = 9
    }
    if (this.rmTimeout) {
      clearTimeout(this.rmTimeout)
    }
    this.rmTimeout = this.rmDataByTimeout(minutes)
  }

  /**
   * emit runSessionTimer by timeout
   * @param minutes - timeout minutes
   * @returns timeout object
   */
  rmDataByTimeout(minutes: number) {
    return setTimeout(() => {
      this.userStateService.isInvalidState = false
      this.runSessionTimer.emit()
    }, minutes * 60 * 1000)
  }

  /**
   * events for:
   *
   * 1. enter / tab clicks
   * 2. upper first letters of some fields
   * 3. mobile - hyphens
   * 4. ssn - hyphens
   * 5. dob - dashes
   * 6. rescan for invalid
   */
  onChanges() {
    this.setEventKeysEnterButton()
    // setEventKeyPressAmount(this, document)
    setUpperFirstLettersSubscribes(this, document)
    setFormMobileAfterChangeAllHyphens(this, document)
    setSSNAfterChangeAllHyphens(this, document)
    setDateAfterChangeAllDashes(this, document)
    showAllInvalid(this, document)
  }

  /**
   * 1. mobile enter event
   * 2. enter / tab desktop move
   * 3. shift + tab desktop reverse move
   * 4. shift + tab from terms of use
   */
  setEventKeysEnterButton() {
    if (this.breakpoints.extraSmall) {
      setEventKeysMobileReturn(this, document)
    } else {
      setEventKeysDesktopTabReturn(this, document)
      setEventKeysDesktopShiftTab(this, document)
      setTermsOfUseReturnTab(this, document)
    }
  }

  /**
   * check current clicked element
   *
   * if element parent had active/inactive
   *
   * than go through (almost) all OTHER form inputs and reset them active/inactive
   *
   * else go throght (almost) all form inputs and reset them active/inactive
   */
  @HostListener('document:click', ['$event'])
  clickout(event) {
    if (!this.events.isClickoutResetActiveInactiveInputs) {
      return
    }
    if (!event?.target?.parentElement) {
      console.warn('prevent clickout error')
      return
    }
    // this.toggleLoader.emit(false)
    let items = event.currentTarget.querySelectorAll("[class*='input-area']")
    if (!items) {
      return
    }
    // if element or parent contains one of the  state
    if (checkIsInputArea(event.target)) {
      const filteredEl = event.target.parentElement.querySelector('input')
      items = _.filter(items, (x) => !x.contains(filteredEl))
    }
    changeInputVisibleStateAll(this, items)
  }

  /**
   * place charSymbol into arr by position;
   *
   * update this.loanInfo[key] with updated arr;
   * @param arr - arr where to place
   * @param position - can be arr.length
   * @param charSymbol - e.g. /
   * @param key - loanInfo[key]
   */
  private insertSymbol(arr: any[], position: number, charSymbol: string, key: string): void {
    arr.splice(position, 0, charSymbol)
    this.loanInfo[key] = arr.join('')
  }

  /**
   * remove charSymbol from arr (by lastIndexOf);
   *
   * update this.loanInfo[key] with updated arr;
   * @param arr - arr where to place
   * @param charSymbol - e.g. /
   * @param key - loanInfo[key]
   */
  private deleteSymbol(arr: any[], charSymbol: string, key: string): void {
    const i = arr.lastIndexOf(charSymbol)
    if (i !== -1) {
      arr.splice(i, 1)
    }
    this.loanInfo[key] = arr.join('')
  }

  onMobileInput(e) {
    mobileHyphensComplete(e, e.target)
  }
  onSSNInput(e) {
    ssnHyphensComplete(e, e.target)
  }

  /**
   * date input handler;
   * fix DOB
   * @param e - event
   */
  public onDateInput(e: any): void {
    const dob = e.target.value
    const arr = Array.from(dob)
    const monthPositon = 2
    const dayPosition = 5
    const dobKey = 'dateOfBirth'
    // hand-made slash

    if (dob.length === 1 && +dob > 1) {
      this.loanInfo[dobKey] = '0' + dob + '/'
      return
    }

    if (dob.length > 1 && dob[1] === '/') {
      return
    }

    if (dob.length === 4 && dob[3] > 3) {
      this.loanInfo[dobKey] = dob.slice(0, dob.length - 1) + '0' + dob[3] + '/'
      return
    }

    if (
      (dob.length === monthPositon || dob.length === dayPosition) &&
      e.inputType !== 'deleteContentBackward' &&
      arr[arr.length - 1] !== '/'
    ) {
      this.insertSymbol(arr, arr.length, '/', dobKey)
    }
  }

  /**
   * toggle hideFullDev
   */
  public showHideFullDev() {
    this.hideFullDev = !this.hideFullDev
  }

  /**
   * handler for focusout amount;
   *
   * place $ if needed, fix amount;
   */
  // public focusOutAmount(): void {
  //   if(this.loanInfo.amount === '$'){
  //     this.loanInfo.amount = ''
  //   }
  //   if (this.loanInfo.amount) {
  //     if (!isNaN(this.loanInfo.amount as any) && ('' + this.loanInfo.amount).length > 4) {
  //       this.loanInfo.amount = +('' + this.loanInfo.amount).slice(0, 4)
  //     }
  //     const strAm = this.loanInfo.amount.toString()
  //     const am = strAm.startsWith('$') ? strAm.slice(1) : strAm
  //     this.loanInfo.amount = '$' + numberWithCommas(am)
  //   }
  //   let loanInfAmount = this.loanInfo.amount
  //   // console.log((this.loanInfo.amount && '' + this.loanInfo.amount).replace(/[$,]/g, '') < this.modalPopups.loanMinValue, (this.loanInfo.amount && '' + this.loanInfo.amount).replace(/[$,]/g, '') > this.modalPopups.loanMaxValue)
  //   if(loanInfAmount && +('' + loanInfAmount).replace(/[$,]/g, '') > +this.modalPopups.loanMaxValue){
  //     this.showMaxAmountError = true
  //     this.showErrorPopupType.emit('max')
  //   } else if (this.loanInfo.address.state === 'HI' && loanInfAmount && +('' + loanInfAmount).replace(/[$,]/g, '') < +this.modalPopups.hawaiiMinValue){
  //       this.showHawaiiError = true
  //       this.showErrorPopupType.emit('hawaii')
  //       //     return { forbiddenName: { value: control.value } }
  //         return
  //   } else if (loanInfAmount && +('' + loanInfAmount).replace(/[$,]/g, '') < +this.modalPopups.loanMinValue){
  //         this.showMinAmountError = true
  //         this.showErrorPopupType.emit('min')
  //   } else {
  //     // this.showErrorPopupType.emit('none')
  //     this.showHawaiiError = false
  //     this.showMaxAmountError = false
  //     this.showMinAmountError = false
  //   }
  //   // if(this.loanInfo.address.state === "HI" && this.loanInfo.amount && (this.loanInfo.amount + "").replace(/[$,]/g, "").slice(0, 4) < this.modalPopups.hawaiiMinValue) {
  //   //   console.log('yep')
  //   //   this.loanForm.controls.amount.setErrors({})
  //   // } else {
  //   //   this.loanForm.controls.amount.updateValueAndValidity();
  //   // }
  // }

  /**
   * toggle 'show' class on target sibling or parent sibling
   * @param e - event
   */
  public toggleNeighbourMessage(e: Event, hide?: boolean): void {
    const showToken = 'show'
    const targetClass = 'modal__input__message'
    const target = e.currentTarget as HTMLElement
    if(hide && !(target.nextElementSibling?.classList.contains(showToken) || target.parentElement.nextElementSibling?.classList.contains(showToken))){  
      return
    }
    // if(hide && (target.nextElementSibling?.classList.contains(checkHideClass) || target.parentElement.nextElementSibling?.classList.contains(checkHideClass))){
    //   return
    // }
    if (target.nextElementSibling?.classList.contains(targetClass)) {
      target.nextElementSibling.classList.toggle(showToken)
    } else if (target.parentElement.nextElementSibling?.classList.contains(targetClass)) {
      target.parentElement.nextElementSibling.classList.toggle(showToken)
    }
  }

  /**
   * handler for focusout event on income
   *
   * place $ in front if needed
   */
  public focusOutIncome() {
    if (this.loanInfo.annualIncome) {
      const strAm = this.loanInfo.annualIncome.toString()
      const am = strAm.startsWith('$') ? strAm.slice(1) : strAm
      this.loanInfo.annualIncome = '$' + numberWithCommas(am)
    }
  }

  /**
   * inject script by url to the document
   * @param url - url of script
   * @returns <script> node
   */
  async loadScript(url): Promise<HTMLScriptElement> {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    this.logger.info('preparing to load...')
    const node = document?.createElement('script')
    node.src = url
    node.type = 'text/javascript'
    node.async = false
    await document.getElementsByTagName('head')[0].appendChild(node)
    return node
  }

  /**
   * uses dynamically loaded script and call TransUnion;
   *
   * setup this.tuSessionId
   * @returns Promise with sessionId
   */
  async tuCall() {
    return new Promise<any>(async (resolve) => {
      ;(await this.loadScript(`${environment.tuScript}`)).addEventListener('load', async (event) => {
        // @ts-ignore
        this.tuSessionId = TrustevV2.Init(this.runtimeConfigService.transUnionPublicKey, function (sessionId) {
          // you should store this sessionId for retrieval at a later point
          this.tuSessionId = sessionId
          // tuId = sessionId;
          resolve(sessionId)
        })
      })
    })
  }

  /**
   * place $ for amount handler;
   *
   * fix value if needed
   * @param e - event
   */
  // public onAmountInput(e: any): void {
  //   if (e.inputType !== 'deleteContentBackward') {
  //   e.target.value = e.target.value.replace(/[$,/a-zA-z]/gi, '')
  //   }
  //   // this.showErrorPopupType.emit('none')
  //   this.logger.info('amount!')
  //   this.logger.info(e.target.value)
  //   const income = '' + this.loanInfo.amount
  //   if (fixIfMore4Clear(this, e)) {
  //     return
  //   } else if (fixIfMore4Dirty(this, e)) {
  //     return
  //   }
  //   // const arr = Array.from(income)
  //   // if (income.length === 1 && e.inputType !== 'deleteContentBackward') {
  //   //   if (e.data && e.data !== '$') {
  //   //     arr.splice(0, 0, '$')
  //   //   }
  //   //   this.loanInfo.amount = arr.join('')
  //   // }
  //   //   if(this.loanInfo.address.state === "HI" && this.loanInfo.amount && (this.loanInfo.amount + "").replace(/[$,]/g, "").slice(0, 4) < this.modalPopups.hawaiiMinValue) {
  //   //   this.loanForm.controls.amount.setErrors({})
  //   // } else {
  //   //   this.loanForm.controls.amount.updateValueAndValidity();
  //   // }
  // }

  /**
   * place $ for income handler
   * @param e - event
   */
  public onIncomeInput(e: any): void {
    const income = '' + this.loanInfo.annualIncome
    const arr = Array.from(income)
    if (income.length === 1 && e.inputType !== 'deleteContentBackward') {
      if (e.data && e.data !== '$') {
        arr.splice(0, 0, '$')
      }
      this.loanInfo.annualIncome = arr.join('')
    }
  }

  /**
   * update loanInfo.address.state
   * @param e - event
   */
  public changeState(e: any): void {
    this.loanInfo.address.state = e.target.value
    inputSelectAriaCheckActiveState(e.target.parentElement)
    this.checkHawaiiPopup(this.loanInfo.address.state)
  }

  /**
   * @async
   * make transunion call;
   *
   * toggle loader and emit data to modal
   */
  private async callSimpleLoan(): Promise<void> {
    this.modalPopups.checkLoanOptionsEnteredData = this.loanInfo
    this.tuSessionId = await this.tuCall()
    this.cdr.detectChanges()
    setTimeout(() => {
      this.cdr.detectChanges()
      this.logger.info(this.tuSessionId)
      this.loanInfo.extFaSessionId = this.tuSessionId
      // this.toggleLoader.emit(true)
      this.dataSubmited.emit({ info: this.loanInfo, coapp: this.insideCoapp })
    }, 200)
  }

  /**
   * @async
   * toggle loader and emit data to modal
   */
  private async callCoappLoan(): Promise<void> {
    setTimeout(() => {
      this.cdr.detectChanges()
      // this.toggleLoader.emit(true)
      this.dataSubmited.emit({ info: this.loanInfo, coapp: this.insideCoapp })
    }, 200)
  }

  /**
   * @async
   * handler for submit form.
   *
   * toggleLoader, call output events
   */
  public async onSubmit(): Promise<void> {
    // TODO: save from here mobile
    // this.loanInfo.mobile
    if (this.submitClicked) {
      return
    }
    this.submitClicked = true
    // this.toggleLoader.emit(true)
    if (this.insideCoapp) {
      await this.callCoappLoan()
    } else {
      await this.callSimpleLoan()
    }
    setTimeout(() => {
      this.submitClicked = false
    }, 1000)
  }

  /**
   * push loanInfo and modalType to localstorage
   */
  private saveFormStore() {
    // this.logger.info(this.loanInfo)
    this.modalStateService.pushToLocalStorage('loanInfo', this.loanInfo)
    // this.logger.info('this.layout')
    // this.logger.info(this.layout)
    if (this.layout && Object.keys(ModalTypes).includes(this.layout)) {
      this.modalStateService.pushToLocalStorage('modalType', this.layout)
    }
  }

  /**
   * save data; goAndScroll
   * @param uri - param of goAndScroll
   * @param card - param of goAndScroll
   */
  public saveStoreGo(uri: string, card: string) {
    setScrollBotToLinks(this, document)
    this.saveFormStore()
    this.page.goAndScroll(uri, card)
  }
}
